<div class="history-feed">

  <!-- Collapsed periodic external syncs -->
  <div class="last-synced" *ngIf="lastSyncedAt" data-test="last-synced">
    <span class="material-icons">sync</span>
    <span>{{ 'permit.manage.history.last_synced' | translate }} · {{ lastSyncedAt | date: 'short' }}</span>
  </div>

  <div class="day-group" *ngFor="let group of dayGroups">
    <div class="day-separator">
      <span class="day-label">{{ group.dayLabel }}</span>
      <span class="separator-line"></span>
    </div>

    <ol class="timeline-list">
      <li class="timeline-entry" *ngFor="let entry of group.entries; let last = last" [class.last]="last" [attr.data-test]="entry.kind === 'status' ? 'status-changes-section' : 'activity-section'">
        <span class="guide-line" aria-hidden="true" *ngIf="!last"></span>

        <div class="icon-dot" [class.sync-dot]="entry.isSync">
          <span class="material-icons entry-icon">{{ entry.icon }}</span>
        </div>

        <div class="entry-content">
          <ng-container *ngIf="entry.kind === 'status'">
            <div class="entry-status-line">
              <div class="entry-status-chip" [style.background-color]="entry.statusColor">
                {{ entry.statusLabel }}
              </div>
              <span class="sync-badge" *ngIf="entry.isSync">
                <span class="material-icons">sync</span>
                {{ 'permit.manage.history.external_sync' | translate }}
              </span>
            </div>

            <div class="entry-detail" *ngIf="entry.reason">
              <span class="label">{{ 'permit.manage.history.reason' | translate }}:</span>
              {{ entry.reason }}
            </div>

            <div class="entry-detail" *ngIf="entry.conditions">
              <span class="label">{{ 'permit.manage.history.conditions' | translate }}:</span>
              {{ entry.conditions }}
            </div>
          </ng-container>

          <ng-container *ngIf="entry.kind === 'activity'">
            <div class="entry-action">{{ entry.actionTitle }}</div>
            <div class="entry-detail" *ngIf="entry.detail">{{ entry.detail }}</div>
          </ng-container>

          <div class="entry-meta">{{ entry.actor }} · {{ entry.time }}</div>
        </div>
      </li>
    </ol>
  </div>

  <!-- Empty State -->
  <div class="no-history" *ngIf="!dayGroups.length && !lastSyncedAt" data-test="empty-message">
    {{ 'permit.manage.history.empty' | translate }}
  </div>

</div>
